
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 100 100","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M99.824 71.7c0 8.628-8.394 15.624-18.574 15.624-10.18 0-18.574-6.996-18.574-15.449 0-8.629 8.394-15.45 18.574-15.45 2.203 0 4.287.376 6.252.957V28.926L37.5 43.75v40.644C37.323 93.008 29.101 100 18.573 100 8.047 100 0 93.008 0 84.375c0-8.629 8.395-15.45 18.574-15.45 2.203 0 4.287.376 6.25.957V24.707c0-2.533 1.965-5.201 4.377-5.96L91.525.29C92.207.129 93.223 0 93.75 0c3.45 0 6.244 2.8 6.25 6.248l-.176 65.451z","fill":"currentColor"}})])
          )
        }
      }
    